import { atom } from 'recoil';

interface IPersonalInfo {
  custNm: string;
  custSeq: string;
  cellNo: string;
  birthDt: string;
  genderCd: string;

  residentNo: any[]; //주민번호뒷자리
  objectTyp: string; //대출목적
  hopefulAmt: string; //대출금액
  salaryAmt: string;
  jobTyp: {};
  joinDt: string; //입사일
  employeeTyp: {}; //직장인, 공무원, 전문직 일때 고용형태
  businessTyp: {}; //개인사업자일때 업종
  houseTyp: string;
  compRegNo: string; //사업자등록번호
  compNm: string;
  healthPayerTyp: string;
  carOwnerYn: string;
  carNo: string;
  reuseYn: string;
  scrapingYn: string;
  trackCd: string;
  transactionNo: string;
  authToken: string;
}

let personalInfo = atom<any>({
  key: 'personalInfo',
  default: {
    custNm: '',
    custSeq: '',
    cellNo: '',
    birthDt: '',
    genderCd: '',

    residentNo: [], //주민번호뒷자리
    objectTyp: '', //대출목적
    hopefulAmt: '', //대출금액
    salaryAmt: '',
    jobTyp: {},
    joinDt: '', //입사일
    employeeTyp: {}, //직장인, 공무원, 전문직 일때 고용형태
    businessTyp: {}, //개인사업자일때 업종
    houseTyp: '',
    compRegNo: '', //사업자등록번호
    compNm: '',
    healthPayerTyp: '01',
    carOwnerYn: '',
    carNo: '',
    debtYn: '',
    debtTyp: '',
    reuseYn: '',
    scrapingYn: '',
    trackCd: '',
    transactionNo: '',
    authToken: '',
    tester: false,
  },
});
export { personalInfo };
